// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RequestResume_wrap__3o6Z6","buttons":"RequestResume_buttons__3zif3"};